'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var error = require('@apollo/client/link/error');
var ClaimsAgentRootProvider = require('./ClaimsAgentRootProvider.js');
var ClaimsApolloProvider$1 = require('../../../common/providers/ClaimsApolloProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const isAgentOperation = name => {
  return name.endsWith('Agent');
};
const retryIfUnauthenticatedMiddleware = (refreshAuth, getAuth) => error.onError(_ref => {
  let {
    forward,
    graphQLErrors,
    operation
  } = _ref;
  if (graphQLErrors && isAgentOperation(operation.operationName)) {
    for (const err of graphQLErrors) {
      switch (err.extensions.code) {
        case 'UNAUTHENTICATED':
          {
            // The onError link function is not async, but it does
            // accept observables.
            const refreshAuthObservable = new client.Observable(subscriber => {
              refreshAuth().then(value => {
                if (subscriber.closed) return;
                subscriber.next(value);
                subscriber.complete();
              }).catch(err => subscriber.error(err));
            });
            // Set the headers with the new auth and try the operation again
            return refreshAuthObservable.flatMap(() => {
              operation.setContext(_ref2 => {
                let {
                  headers = {}
                } = _ref2;
                return {
                  headers: {
                    ...headers,
                    authorization: getAuth()
                  }
                };
              });
              return forward(operation);
            });
          }
      }
    }
  }
});
const authHeaderMiddleware = getAuth => new client.ApolloLink((operation, forward) => {
  // add the authorization to the headers
  if (isAgentOperation(operation.operationName)) {
    operation.setContext(_ref3 => {
      let {
        headers = {}
      } = _ref3;
      return {
        headers: {
          ...headers,
          authorization: getAuth()
        }
      };
    });
  }
  return forward(operation);
});
const ClaimsApolloProvider = _ref4 => {
  let {
    children,
    config
  } = _ref4;
  const {
    getAuth,
    refreshAuth
  } = ClaimsAgentRootProvider.useClaimsAgentRoot();
  return /*#__PURE__*/React__default["default"].createElement(ClaimsApolloProvider$1.ClaimsApolloProvider, {
    config: {
      ...config,
      links: [authHeaderMiddleware(getAuth), retryIfUnauthenticatedMiddleware(refreshAuth, getAuth)]
    }
  }, children);
};

exports.ClaimsApolloProvider = ClaimsApolloProvider;
